import useSWR from 'swr';
import { toolTemplateService, isApiError } from '@dopomogai/api-client';
import type { UUID, ToolTemplateResponse } from '@dopomogai/types';
import { AgentKitError } from '../types';

export const useToolTemplateOverride = (agentId: UUID | null, toolSlug: string | null) => {
  const key = agentId && toolSlug ? [`tool-template/${agentId}/${toolSlug}`, agentId, toolSlug] : null;

  const { data, error, isLoading, mutate } = useSWR<ToolTemplateResponse, AgentKitError>(
    key,
    async (args: [string, UUID, string]) => {
      const [, a, slug] = args;
      const res = await toolTemplateService.getAgentToolTemplate(a, slug);
      if (isApiError(res)) throw new AgentKitError(res.message, res);
      return res;
    }
  );

  const update = async (template: string | null) => {
    if (!agentId || !toolSlug) throw new AgentKitError('Missing agent or tool slug.');
    const res = await toolTemplateService.setAgentToolTemplate(agentId, toolSlug, { template });
    if (isApiError(res)) throw new AgentKitError(res.message, res);
    mutate();
    return res;
  };

  return {
    effective_template: data?.effective_template ?? null,
    override_template: data?.override_template ?? null,
    base_template: data?.base_template ?? null,
    isLoading,
    error,
    update,
    mutate,
  };
};